import React from 'react'

const Footer =()=>{
  return(
    <div>Footerだよ</div>
  )
}

export default Footer